import { css } from 'pretty-lights';
export const contentWidth = 700;
export const padding = 15;

